export default "__VITE_ASSET__3e9c2430__"